export default "<div #dialerRef class=\"n2p-web-dialer\"></div>\n"